module.exports = __webpack_public_path__ + "static/media/cihan.2b09f8a2.jpeg";